export const IndexSEO = {
  metaTitle: 'Get Gold Loan Prime | MuthootFincorpOne',
  metaDescription:
    'Experience the ease of obtaining a Gold Loan from the comfort of your home. MuthootFincorpOne offers flexible options and quick approval. Apply now!',
  metaOGDescription:
    'Experience the ease of obtaining a Gold Loan from the comfort of your home. MuthootFincorpOne offers flexible options and quick approval. Apply now!',
};
export const AuthSEO = {
  metaTitle: 'Secure Authentication | Muthoot FincorpOne',
  metaDescription:
    'Experience secure authentication with Muthoot FincorpOne. Access your financial services confidently. Your financial well-being is our priority.',
  metaOGDescription:
    'Experience secure authentication with Muthoot FincorpOne. Access your financial services confidently. Your financial well-being is our priority.',
};

export const GoldLoanSEO = {
  metaTitle: 'Gold Loan Apply Online | MuthootFincorpOne',
  metaDescription:
    "Find the best gold loan interest rates and calculate your loan's interest with our online calculator. Apply for a gold loan online at MuthootFincorpOne today!",
  metaOGDescription:
    "Find the best gold loan interest rates and calculate your loan's interest with our online calculator. Apply for a gold loan online at MuthootFincorpOne today!",
};

export const DigitalGoldSEO = {
  metaTitle: 'Buy & Sell eSwarna Digital Gold Online | MuthootFincorpOne',
  metaDescription:
    'Make a smart investment choice with eSwarna Digital gold. Buy and sell eSwarna Digital gold online conveniently at MuthootFincorpOne. Explore the best rates for online eSwarna Digital gold purchase.',
  metaOGDescription:
    'Make a smart investment choice with eSwarna Digital gold. Buy and sell eSwarna Digital gold online conveniently at MuthootFincorpOne. Explore the best rates for online eSwarna Digital gold purchase.',
};

export const ForexSEO = {
  metaTitle: 'Fast Forex Money Transfer Services Online | MuthootFincorpOne',
  metaDescription:
    'Experience hassle-free forex trading online with MuthootFincorpOne. Exchange currency, transfer funds, and make international money transfers with confidence.',
  metaOGDescription:
    'Experience hassle-free forex trading online with MuthootFincorpOne. Exchange currency, transfer funds, and make international money transfers with confidence.',
};

export const NCDSEO = {
  metaTitle:
    'Muthoot Fincorp One NCD - Invest in Non-Convertible Debentures for High Returns',
  metaDescription:
    "Explore secure and high-return investment opportunities with Muthoot Fincorp One's NCDs.Offering flexible tenures and attractive interest rates.",
  metaOGDescription:
    "Explore secure and high-return investment opportunities with Muthoot Fincorp One's NCDs.Offering flexible tenures and attractive interest rates.",
};

export const NCDGeneralHelpSEO = {
  metaTitle:
    'Muthoot Fincorp One NCD - Invest in Non-Convertible Debentures for High Returns',
  metaDescription:
    "Explore secure and high-return investment opportunities with Muthoot Fincorp One's NCDs.Offering flexible tenures and attractive interest rates.",
  metaOGDescription:
    "Explore secure and high-return investment opportunities with Muthoot Fincorp One's NCDs.Offering flexible tenures and attractive interest rates.",
};

export const BuyForexSEO = {
  metaTitle: 'Buy Forex Online | MuthootFincorpOne',
  metaDescription:
    'Buy forex online and engage in seamless forex trading. Benefit from secure and efficient forex money exchange and international money transfer services.',
  metaOGDescription:
    'Buy forex online and engage in seamless forex trading. Benefit from secure and efficient forex money exchange and international money transfer services.',
};

export const BuyForexHelpSEO = {
  metaTitle: 'Buy Forex Online | MuthootFincorpOne',
  metaDescription:
    'Buy forex online and engage in seamless forex trading. Benefit from secure and efficient forex money exchange and international money transfer services.',
  metaOGDescription:
    'Buy forex online and engage in seamless forex trading. Benefit from secure and efficient forex money exchange and international money transfer services.',
};

export const SellForexSEO = {
  metaTitle:
    'Sell Forex - Secure and Convenient Currency Exchange | MuthootFincorpOne',
  metaDescription:
    'Effortlessly sell forex online and enjoy seamless forex money exchange and international money transfer services. Trust us for secure transactions and competitive rates.',
  metaOGDescription:
    'Effortlessly sell forex online and enjoy seamless forex money exchange and international money transfer services. Trust us for secure transactions and competitive rates.',
};

export const SellForexHelpSEO = {
  metaTitle:
    'Sell Forex - Secure and Convenient Currency Exchange | MuthootFincorpOne',
  metaDescription:
    'Effortlessly sell forex online and enjoy seamless forex money exchange and international money transfer services. Trust us for secure transactions and competitive rates.',
  metaOGDescription:
    'Effortlessly sell forex online and enjoy seamless forex money exchange and international money transfer services. Trust us for secure transactions and competitive rates.',
};

export const ForexCardSEO = {
  metaTitle: 'Buy Forex Cards Online | MuthootFincorpOne',
  metaDescription:
    'Make forex trading and money exchange easier with our forex cards. Buy forex online and enjoy secure and efficient international money transfer.',
  metaOGDescription:
    'Make forex trading and money exchange easier with our forex cards. Buy forex online and enjoy secure and efficient international money transfer.',
};

export const ForexCardHelpSEO = {
  metaTitle: 'Buy Forex Cards Online | MuthootFincorpOne',
  metaDescription:
    'Make forex trading and money exchange easier with our forex cards. Buy forex online and enjoy secure and efficient international money transfer.',
  metaOGDescription:
    'Make forex trading and money exchange easier with our forex cards. Buy forex online and enjoy secure and efficient international money transfer.',
};

export const ForexMoneyTransferSEO = {
  metaTitle: 'International Money Transfer | Muthoot FinCorp ONE',
  metaDescription:
    'Money Transfer, Foreign Currency Exchange, Send Money Abroad, Forex Cards - Muthoot FinCorp ONE',
  metaOGDescription:
    'Money Transfer, Foreign Currency Exchange, Send Money Abroad, Forex Cards - Muthoot FinCorp ONE',
};

export const AboutUsSEO = {
  metaTitle: 'Discover Our Story | MuthootFincorpOne',
  metaDescription:
    'At MuthootFincorpOne, we are driven by trust and a passion for serving our customers. Explore our journey and discover our unwavering commitment to financial services.',
  metaOGDescription:
    'At MuthootFincorpOne, we are driven by trust and a passion for serving our customers. Explore our journey and discover our unwavering commitment to financial services.',
};

export const CareersSEO = {
  metaTitle: 'Explore Exciting Career Opportunities | MuthootFincorpOne',
  metaDescription:
    'Looking for a meaningful career? MuthootFincorpOne.com offers exciting opportunities, competitive benefits, and a chance to make a real impact.',
  metaOGDescription:
    'Looking for a meaningful career? MuthootFincorpOne.com offers exciting opportunities, competitive benefits, and a chance to make a real impact.',
};

export const BlogsSEO = {
  metaTitle: 'Financial Tips and Advice | MuthootFincorpOne',
  metaDescription:
    'Stay updated with our insightful finance blogs, covering topics like investments, gold & digital loans, and financial planning. Explore valuable information at MuthootFincorpOne.',
  metaOGDescription:
    'Stay updated with our insightful finance blogs, covering topics like investments, gold & digital loans, and financial planning. Explore valuable information at MuthootFincorpOne.',
};

export const PrivacyPolicySEO = {
  metaTitle: 'Safeguarding Your Personal Information | MuthootFincorpOne',
  metaDescription:
    'Your privacy matters to us. Explore our privacy policy to understand how we handle and protect your personal information at MuthootFincorpOne.',
  metaOGDescription:
    'Your privacy matters to us. Explore our privacy policy to understand how we handle and protect your personal information at MuthootFincorpOne.',
};

export const TermsConditionsSEO = {
  metaTitle: 'Understanding Our Terms and Conditions | MuthootFincorpOne',
  metaDescription:
    'At MuthootFincorpOne, we value transparency. Read our terms and conditions to understand the guidelines for using our platform and accessing our services.',
  metaOGDescription:
    'At MuthootFincorpOne, we value transparency. Read our terms and conditions to understand the guidelines for using our platform and accessing our services.',
};

export const ApplyGoldLoanSEO = {
  metaTitle: 'Muthoot FinCorp ONE |Apply Gold Loan Online',
  metaDescription:
    'Gold Loan Online Flexible Repayment. No processing fee & Quick Approval | Muthoot FinCorp ONE',
  metaOGDescription:
    'Gold Loan Online Flexible Repayment. No processing fee & Quick Approval | Muthoot FinCorp ONE',
};

export const RegulatoryComplianceSEO = {
  metaTitle: 'Regulatory Standards at a Glance | MuthootFincorpOne',
  metaDescription:
    'We prioritize regulatory compliance to safeguard your financial transactions. Explore our practices and measures at MuthootFincorpOne for peace of mind.',
  metaOGDescription:
    'We prioritize regulatory compliance to safeguard your financial transactions. Explore our practices and measures at MuthootFincorpOne for peace of mind.',
};

export const HelpPageSEO = {
  metaTitle: 'Customer Support, Assistance for You | MuthootFincorpOne',
  metaDescription:
    'Get the assistance you need at MuthootFincorpOne. Our help center provides prompt support, helpful resources, and solutions to your queries and concerns.',
  metaOGDescription:
    'Get the assistance you need at MuthootFincorpOne. Our help center provides prompt support, helpful resources, and solutions to your queries and concerns.',
};

export const OutwardRemittancesSEO = {
  metaTitle: 'Streamlined Forex Money Exchange | MuthootFincorpOne',
  metaDescription:
    'Make international money transfer easy with our outward remittance solutions. Enjoy hassle-free forex money exchange and secure forex money transfer services.',
  metaOGDescription:
    'Make international money transfer easy with our outward remittance solutions. Enjoy hassle-free forex money exchange and secure forex money transfer services.',
};

export const OutwardRemittancesHelpSEO = {
  metaTitle: 'Streamlined Forex Money Exchange | MuthootFincorpOne',
  metaDescription:
    'Make international money transfer easy with our outward remittance solutions. Enjoy hassle-free forex money exchange and secure forex money transfer services.',
  metaOGDescription:
    'Make international money transfer easy with our outward remittance solutions. Enjoy hassle-free forex money exchange and secure forex money transfer services.',
};

export const GLFHApplicationProcessHelpSEO = {
  metaTitle: 'Gold Loan Prime | MuthootFincorpOne',
  metaDescription:
    'Get the best gold loan interest rate per gram with our online application process. Calculate your EMI using our gold loan EMI calculator and apply for a gold loan prime.',
  metaOGDescription:
    'Get the best gold loan interest rate per gram with our online application process. Calculate your EMI using our gold loan EMI calculator and apply for a gold loan prime.',
};

export const ForexGeneralHelpSEO = {
  metaTitle: 'General Forex Information | MuthootFincorpOne',
  metaDescription:
    'Gain valuable insights about forex trading, money exchange, and international money transfer. Explore our services to buy forex online conveniently.',
  metaOGDescription:
    'Gain valuable insights about forex trading, money exchange, and international money transfer. Explore our services to buy forex online conveniently.',
};

export const DGBuySellHelpSEO = {
  metaTitle: 'Buy and Sell eSwarna Digital gold Online | MuthootFincorpOne',
  metaDescription:
    'Explore the convenience of buying and selling eSwarna Digital gold online. Make the best investment with competitive eSwarna Digital gold rates and hassle-free online transactions.',
  metaOGDescription:
    'Explore the convenience of buying and selling eSwarna Digital gold online. Make the best investment with competitive eSwarna Digital gold rates and hassle-free online transactions.',
};

export const GLFHPaymentsRelatedHelpSEO = {
  metaTitle: 'GLFH Payments | MuthootFincorpOne',
  metaDescription:
    'Manage your GLFH payments conveniently from home. Explore our online options and make hassle-free payments for your gold loan.',
  metaOGDescription:
    'Manage your GLFH payments conveniently from home. Explore our online options and make hassle-free payments for your gold loan.',
};

export const SafetyGLFHHelpSEO = {
  metaTitle: 'Secure Gold Loan Services | MuthootFincorpOne',
  metaDescription:
    'Ensuring the safety of your GLFH gold loan is our top priority. Enjoy peace of mind with competitive interest rates and secure online transactions.',
  metaOGDescription:
    'Ensuring the safety of your GLFH gold loan is our top priority. Enjoy peace of mind with competitive interest rates and secure online transactions.',
};

export const SIPHelpSEO = {
  metaTitle: 'Online eSwarna Digital gold Purchase | MuthootFincorpOne',
  metaDescription:
    'Invest in eSwarna Digital gold through our convenient SIP program. Buy and sell eSwarna Digital gold online for the best investment returns. Explore online purchase options and track eSwarna Digital gold rates.',
  metaOGDescription:
    'Invest in eSwarna Digital gold through our convenient SIP program. Buy and sell eSwarna Digital gold online for the best investment returns. Explore online purchase options and track eSwarna Digital gold rates.',
};

export const DGGeneralHelpSEO = {
  metaTitle: 'Best eSwarna Digital gold Investment | MuthootFincorpOne',
  metaDescription:
    'Get started with best eSwarna Digital gold investment today. Buy and sell eSwarna Digital gold online for a profitable investment. Stay informed about eSwarna Digital gold rates and enjoy online purchase convenience.',
  metaOGDescription:
    'Get started with best eSwarna Digital gold investment today. Buy and sell eSwarna Digital gold online for a profitable investment. Stay informed about eSwarna Digital gold rates and enjoy online purchase convenience.',
};

export const DGGeneralCoupons = {
  metaTitle:
    'eSwarna Digital gold Coupons | Discounts and Offers | Muthoot FincorpOne',
  metaDescription:
    'Explore the latest eSwarna Digital gold coupon codes and offers at Muthoot FincorpOne. Start investing in eSwarna Digital gold today and avail exciting discounts.',
  metaOGDescription:
    'Explore the latest eSwarna Digital gold coupon codes and offers at Muthoot FincorpOne. Start investing in eSwarna Digital gold today and avail exciting discounts.',
};

export const DGGeneralGiftGold = {
  metaTitle: 'Gift Gold Online | Share Precious Moments | Muthoot FincorpOne',
  metaDescription:
    'Give the gift of gold online through Muthoot FincorpOne. Celebrate special occasions with the timeless and valuable present of gold.',
  metaOGDescription:
    'Give the gift of gold online through Muthoot FincorpOne. Celebrate special occasions with the timeless and valuable present of gold.',
};

export const AboutGLFHHelpSEO = {
  metaTitle: 'About Gold Loan Prime | MuthootFincorpOne',
  metaDescription:
    'Learn about our convenient Gold Loan Prime service. Get a gold loan without leaving your home. Secure financing with ease and simplicity.',
  metaOGDescription:
    'Learn about our convenient Gold Loan Prime service. Get a gold loan without leaving your home. Secure financing with ease and simplicity.',
};

export const ForexIbanSeo = {
  metaTitle:
    'IBAN Codes for Hassle-free Forex Money Transfer | MuthootFincorpOne',
  metaDescription:
    'Get your IBAN codes for quick and convenient forex money exchange at MuthootFincorpOne. Experience safe and efficient international money transfers.',
  metaOGDescription:
    'Get your IBAN codes for quick and convenient forex money exchange at MuthootFincorpOne. Experience safe and efficient international money transfers.',
};

export const ForexSwiftSeo = {
  metaTitle: 'Swift Codes for Forex Money Exchange | MuthootFincorpOne',
  metaDescription:
    'Access swift codes for quick forex money exchange and enjoy secure international money transfers at MuthootFincorpOne. Buy forex online hassle-free.',
  metaOGDescription:
    'Access swift codes for quick forex money exchange and enjoy secure international money transfers at MuthootFincorpOne. Buy forex online hassle-free.',
};

export const ForexFindIfsc = {
  metaTitle:
    'Muthoot Fincorp IFSC Code Finder | Locate Your Branch Code Online',
  metaDescription:
    'Easily find the IFSC code for any Muthoot Fincorp branch using our convenient online tool. Ensure seamless transactions with accurate IFSC information.',
  metaOGDescription:
    'Easily find the IFSC code for any Muthoot Fincorp branch using our convenient online tool. Ensure seamless transactions with accurate IFSC information.',
};

export const ForexBranchLocator = {
  metaTitle:
    'Muthoot Fincorp Forex Branch Locator | Discover Nearest Forex Service Centers',
  metaDescription:
    'Locate the nearest Muthoot Fincorp Forex branch using our branch locator. Access foreign exchange services effortlessly for your travel and financial needs.',
  metaOGDescription:
    'Locate the nearest Muthoot Fincorp Forex branch using our branch locator. Access foreign exchange services effortlessly for your travel and financial needs.',
};

export const ForexReferAndEarnSEO = {
  metaTitle: 'Refer and Earn: Unlock Rewards for Referring Friends',
  metaDescription:
    'Join our Refer and Earn program and start earning rewards by referring friends. Share the benefits, earn and grow your network.',
  metaOGDescription:
    'Join our Refer and Earn program and start earning rewards by referring friends. Share the benefits, earn and grow your network.',
};
